import '../../App.css';
import React, {Component, Container} from 'react';
import {Image,Navbar, Nav, NavItem, NavDropdown} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import IYFAONavBarTop from "./navbar";
import IYFAOFooter from "./footer";
const applyurl = "https://docs.google.com/forms/d/e/1FAIpQLScoSIrXM_CqsXcaw6mSZmB8f6E1MoXcis3QFeRaE_SO6cP_5A/viewform?usp=sf_link"

// Each artwork: id = Google Drive FILE_ID (the part between /d/ and /view)
const artworkList = [
  { id: "1AOmXMkJK16cuplL-49brbemuhmSbRXF_", title: "Eliz Cheong - Abyss Of Dreams", group:"P05" },
  { id: "1jEQPjESWbJGiLqSt-PfOUFBOBPZY1yqC", title: "Loh Zhi Ying - The Clockwork Sonata", group:"P04"  },
  { id: "1TVDKuHW5OIhmvo6dWLYsw4WJZcKRSK7l", title: "Tan Ai Fei - The Quite House", group:"P04" },
  { id: "1ozmJNwkeIbltz1zY69vtKBxaMwocUc7K", title: "Teerachai Suksawas - BLACK RAIN", group:"P06" },
  { id: "1-e_aGazfkJ99VeDqLaDeSfoXWOb7Yait", title: "David Goh Yi Hen - Rage of the King", group:"P06"  },
  { id: "1YBXxhdFD028H4r35O8Znu-lREPaMH6w7", title: "Chong Kok Weng - A Piece of Love", group:"P06"  },
  { id: "1UOqfuoxgACzKBKLkCohoqBvTy-z5n2ra", title: "Diong Li En - Small Waterfall", group:"P04" },
  { id: "1csTID6oa_jfD63NK9UqbeDoWl03PQNOU", title: "Marion See Leen - Mythic Forest", group:"P05" },
  { id: "1danSr-bIUrhI8VXRv2bCE0xjsdMm5ohp", title: "Saravthy Mega - Peace", group:"T03"  },
  { id: "1sDB97lhKHiDi5Q0RMJPWuQXc3LZpI16N", title: " Foo Swee Wee - Dance of Luminous Wings", group:"P06"  },
  { id: "1yi_ayNDauuwl0bK5SuajA6Uc02QqDitf", title: "Leong Wui Yue - Herald of Dawn", group:"P04"  },
  { id: "1paerG3p28v5RhmlVYxHGSxaGqPptzo4-", title: "Harshini - The Lonely Snowman", group:"P03" },
  { id: "1dBHl7X96NvVxUfhmvL2wqLTAkxYZc3en", title: "Tan Shu Hui - Where the Magic Starts", group:"P05" },
  { id: "18N7yynZ_BZKfuGicU5jgiL11kJUaoBBN", title: "Leong Le Xuan - Floral Predator ", group:"P05" },
  { id: "1gZ8BElILq8WCRlbXzIuqBe3DjW0V6dDq", title: "Jong Kun Lee - Bicycle", group:"P05" },
  { id: "1lSNVRzyClolKz0ap8jJWv9k84JPf_dGJ", title: "Steve Chan - World Peace", group:"T03"  },
  { id: "1odnzUTIu-lSD0dn_thYjRNR0iPyHo1TG", title: "Punnanat Aiammain - Time of peace", group:"T05"  },
  { id: "1S5A4IP0a_oTRq_QY6M41M8U1wL41EnrN", title: "Tan Yee Qi Audrey - Neon Regret", group:"P05"  },
  { id: "1xZkuuPAH00Zj43plXqkBpuTh2itDaIiW", title: "Achavee Sukrat - Aurora", group:"P01"  },
  { id: "193_MYeLxyxu3gGxiu_ZJaPapSl8uTrTb", title: "Aleyna Yu Han Soh - Grace Beneath the Stars", group:"P03"  },
  { id: "1YbJLF3aHrf3BSO_r4llrGn9LvcruHhbP", title: "Cheong Mei Quin - Companion", group:"P06"  },
  { id: "1Ju_joOcz-izFCNRXAB-BL7aWDtxg_Buw", title: "Won Siew Chin - Ladybugs are on the straws", group:"P06"  },
  { id: "1yf589FNGivqHA8vmAghjPwbnvz-seYMt", title: "Ang Yan Hoon - Lantern of the Lost Woods", group:"P06"  },
  { id: "13Ca6OEyusr923qVSH-5hUH8m-zVN5QVP", title: "Parisa Kiattansakul - Science for the environment and society", group:"P02"  },
  { id: "1GMEZ0KFXCrw-B-tBHMEgx_-WsT0YB62K", title: "Chai Ying Ying - Dancing at the Harvest Moon", group:"P06"  },
  { id: "1YxATlJ0ZYIUfuaQCK_t1VFtooRZUhxG0", title: "Lee Tat Kui - Luminous Petals", group:"P06"  },
  { id: "1bPwStb-yB8tnAQsea3-_oyIRJV4fTXNp", title: "Alice Lim Fui Li - Unfading Blue", group:"P06"  },
  { id: "1HGijb-wq6l0HMdo-AWIlyolM29yjYfiB", title: "Nadia Wirin - Equality", group:"T03"  },
  { id: "1Uf8b8v9_OWjH-pMlYoXIjq-OzZZV4Wm_", title: "Rebecca Christella Hendarson - Seeing the World with Wonder", group:"T03"  },
  { id: "1rJkz5JLZXB7fecULO6P4nV3QRDQSsBnU", title: "Wong Siew Yoong - Miniature World In The Gloom", group:"T06"  },
  { id: "1RrgrTRYWfdDL8yNet4VkQoBHtFYQ9dJL", title: "Oung Shao Phing - Breath Of Forest", group:"T06"  },
  { id: "1mRCee7Vs-QjvZoxgdb75aqG0c5RAXXht", title: " Hew Chin Lee - Melody in Bloom", group:"T06"  },
  { id: "100gKCo5mZVD2jYD5_OCUEwGjTOtBRsfv", title: " Lau V-Shane - Harmony in Bloom", group:"T06"  },
  { id: "1duMmvSQULeLADUaREQ7AR5TMOGtC0IBQ", title: " Ng Wan Cheng - The Stillness Within Silence", group:"T06"  },
 
  
  
 
 
];

class IypcWinnerShowcase extends Component {
  constructor(props){
    super(props);
    this.state = {  
      currentArtworkId: artworkList[0].id,
    };

    this.setval = this.setval.bind(this)
    this.handleArtworkSelect = this.handleArtworkSelect.bind(this)
  }
  componentDidMount(){
    document.title="International Young Painter Open Competition"
    var link1 = document.getElementById('favicon')
    var link2 = document.getElementById('touchicon')
    link1.href="/assets/iypo-logo.PNG"
    link2.href="/assets/iypo-logo.PNG"
    this.props.setval({comp:"iypo",lang:"en"})  
  }
  setval(obj){
    this.setState(obj)
  }
  handleArtworkSelect(id){
    this.setState({currentArtworkId: id})
  }

  render(){
    const { currentArtworkId } = this.state;

    return (
      <div>
       {/* <img src="/assets/term.png" width="100%" style={{borderRadius:"0px"}} /> */}
      <div style={{display:"flex",flexDirection:"column",paddingLeft:"10%",paddingRight:"10%",paddingTop:"4%",paddingBottom:"2%",textAlign:"left",fontFamily:"Arial",marginBottom:"200px"}}>

      <h1 style={{textAlign:"center",fontSize:"2.5em",marginBottom:"4%"}}><em>Artwork Showcase</em></h1>

      <div style={{display:"flex",gap:"20px",flexWrap:"wrap"}}>

        {/* Left side - Main artwork preview */}
        <div style={{flex:"2",minWidth:"300px"}}>
          <div style={{position:"relative",paddingBottom:"75%",height:0,overflow:"hidden",borderRadius:"12px",boxShadow:"0 4px 12px rgba(0,0,0,0.2)",background:"#f0f0f0"}}>
            <iframe
              style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
              src={`https://drive.google.com/file/d/${currentArtworkId}/preview`}
              title="Artwork preview"
              allow="autoplay"
              allowFullScreen
            />
          </div>
        </div>

       {/* Right side - Scrollable artwork list */}
<div style={{
  flex: "1",
  minWidth: "250px",
  maxHeight: "500px",
  overflowY: "auto",
  border: "1px solid #ddd",
  borderRadius: "12px",
  padding: "12px",
  background: "#fafafa",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
}}>
  <h5 style={{ marginBottom: "12px", textAlign: "center" }}>Artworks</h5>

  {artworkList.map((art) => {
    const isActive = currentArtworkId === art.id;
    return (
      <div
        key={art.id}
        onClick={() => this.handleArtworkSelect(art.id)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "8px",
          marginBottom: "8px",
          borderRadius: "8px",
          cursor: "pointer",
          background: isActive ? "#ff9800" : "#ffffff",
          color: isActive ? "#ffffff" : "#222222",
          border: isActive ? "2px solid #e68900" : "1px solid #ddd",
          boxShadow: isActive
            ? "0 2px 8px rgba(255, 152, 0, 0.4)"
            : "0 1px 3px rgba(0, 0, 0, 0.08)",
          transition: "all 0.2s ease",
          transform: isActive ? "scale(1.02)" : "scale(1)",
        }}
      >
        {/* Thumbnail wrapper with overlay */}
        <div style={{
          position: "relative",
          width: "80px",
          height: "60px",
          flexShrink: 0,
        }}>
         
          {/* Transparent overlay to block the fullscreen button */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              width: "30px",
              height: "30px",
              cursor: "default",
            }}
          />
        </div>

        <span style={{
          fontSize: "0.95em",
          fontWeight: isActive ? "600" : "400",
          lineHeight: "1.3",
        }}>
          {art.title}
        </span>
      </div>
    );
  })}
</div>

      </div>
      </div>
      </div>
    );
  }
  }
  

export default IypcWinnerShowcase;